import React, { useEffect, useState } from 'react'
import blogServices from '../../services/BlogService'
import Loading from '../feedback/Loading'
import FetchError from '../feedback/FetchError'
import { Link } from 'react-router-dom'
import HomeBlogItem from './HomeBlogItem'
import EmptyList from '../feedback/EmptyList'

function BlogListHome() {
    const [posts, setPosts] = useState()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState()

    useEffect(() => {
        setError()
        blogServices.getBlogs('').then(
            res => {
                setPosts(res.data)
                setLoading(false)
            },
            err => {
                setError(err)
                setLoading(false)
            }
        )
    }, [])
    useEffect(() => { }, [posts])
    useEffect(() => { }, [loading])
    useEffect(() => { }, [error])
    return (
        <div className='container mx-auto px-3'>
            <div className=" mb-16">
                <h2 className="text-3xl font-black font-headline mb-4 text-on-surface">
                    Construction Insights
                </h2>
                <p className="text-on-surface-variant max-w-2xl">
                    Expert advice on navigating the construction industry in Kenya.
                </p>
            </div>
            {loading ? (<Loading />) : (
                <div>
                    {error ? (<FetchError error={error} />) : (
                        <div>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                                {posts?.results?.slice(0, 6)?.map((post, idx) => (
                                    <HomeBlogItem key={idx} post={post} />
                                ))}
                            </div>
                            {posts.count < 1 && (
                                <EmptyList item={"Blog Post"} />
                            )}
                            <div className="flex justify-center">
                                <Link to={'/blog'} className='mt-16 px-8 py-4 bg-primary text-white font-bold rounded-xl hover:bg-primary-container transition-all'>View More Posts</Link>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

export default BlogListHome